import React from 'react';
import { Dialog, FormGrid } from '../../../primitives';
import { FormattedMessage } from 'react-intl';
import { FormControlsForFields } from '../../../schemed';
import { FootnotePropsSchema } from './types';
import { FootnoteEditData } from './useFootnotesEdit';
import isHotkey from 'is-hotkey';

interface Props {
  data: FootnoteEditData;
}

export const FootnoteEditDialog = (props: Props) => {
  const { data } = props;


  if(!data.editingContext) {
    return null;
  }

  return (
    <Dialog
      isOpen={!!data.editingContext}
      close={() => {
        data.completeEditing();
      }}
      onKeyDown={e => {
        if(isHotkey("mod+Enter", e)) {
          data.completeEditing();
        }
      }}
      dialogTitle={<FormattedMessage id="powerdoc.plugins.footnote.dialog_title" />}
      maxWidth="md"
      fullWidth
      noFullscreen>

      <FormGrid
        columns="1fr"
        contentEditable={false}>
        <FormControlsForFields
          fields={[
            ["footnote_text", { controlProps: { autoFocus: true }}],
            ["label"],
          ]}
          schema={FootnotePropsSchema}
          data={data.elementEdit}
          onChange={(o,c)=> data.update(c)}
          />
          
      </FormGrid>
      
  </Dialog>
  );
}
